module.exports = __webpack_public_path__ + "static/media/profilelogo6.8c8cc607.png";